import { useState, useEffect } from "react";

import { auth, database } from "../utils/firebase.js";
import { trimDate, getDeviceType } from "../utils/helper.js";

function SignUp() {
  const [userId, setUserId] = useState(localStorage.getItem("userId"));

  useEffect(() => {
    const signInAnonymously = async () => {
      if (userId) {
        return;
      }
      try {
        await auth.signInAnonymously();
        auth.onAuthStateChanged((firebaseUser) => {
          if (firebaseUser) {
            if (localStorage.getItem("userId") === null) {
              setUserId(firebaseUser.uid);
              localStorage.setItem("userId", firebaseUser.uid);

              database.ref("users/" + firebaseUser.uid).set({
                timestamp: trimDate(),
                deviceType: getDeviceType(),
              });
            }
            console.log("User Created");
          } else {
            console.log("User is signed out");
          }
        });
      } catch (error) {
        console.error("Error signing in anonymously:", error);
      }
    };

    signInAnonymously();
  }, [userId]);

  return null;
}

export default SignUp;
